module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Sport Aluminum + Fog Open.d5f993d2.png";